<h2 mat-dialog-title>Adicionar aos segmentos</h2>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="submiting"></mat-progress-bar>
<mat-dialog-content>

    <div class="controls">
        <form (submit)="addSegment()" [formGroup]="form">
            <div class="row">
                <mat-form-field appearance="outline">
                    <input type="text" matInput placeholder="Nome do segmento" formControlName="name"/>
                </mat-form-field>
                <button mat-icon-button type="submit" color="primary" [disabled]="form.pristine && this.segments.length === 0">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </form>
    </div>

    <div class="empty-content" *ngIf="segments.length === 0 && submiting == false">
        <span class="mat-body-2">Nenhum segmento encontrado</span>
        <button mat-stroked-button color="primary" (click)="addSegment()">Cadastrar novo segmento</button>
    </div>

    <mat-selection-list #segmentList>
        <ng-container *ngFor="let segment of segments">
            <mat-list-option [value]="segment" [disabled]="segment.hasImportSchedule">
                <h3 matLine>{{ segment.name }}</h3>
                <p matLine>Criado em {{ segment.date_added | date:'dd/MM/yyyy' }}</p>
                <small matLine>{{ segment.members }} membros</small>
                <span matLine *ngIf="segment.hasImportSchedule">
                    <div class="custom-badge" style="margin-left: 0px; background-color: orangered;">Importação agendada</div>
                </span>
            </mat-list-option>
        </ng-container>        
    </mat-selection-list>

</mat-dialog-content>
<mat-dialog-actions>
    <button color="accent" mat-button mat-dialog-close>Cancelar</button>
    <button color="primary" mat-raised-button [disabled]="disabledButton()" (click)="importSegment()">Adicionar</button>
</mat-dialog-actions>